import { ApiAction } from '../../../Helpers/actions'
import { AppThunk } from '../../../root.reducer'
import * as api from './evaluationForm.api'
import { GET_ACTIVE_EVALUATION_FORMS } from './evaluationForm.constants'

export const getActiveEvaluationForms = (): AppThunk => {
  return async dispatch => {
    dispatch({ type: GET_ACTIVE_EVALUATION_FORMS.REQUESTED })
    try {
      const response = await api.getActiveEvalForms()
      dispatch({ response, type: GET_ACTIVE_EVALUATION_FORMS.SUCCESS })
      return response
    } catch (error) {
      dispatch({ error, type: GET_ACTIVE_EVALUATION_FORMS.FAILURE })
      throw error
    }
  }
}

export type EvalFormAction = ApiAction<typeof GET_ACTIVE_EVALUATION_FORMS, api.EvalForm[]>
